const methods = {
  formataDataDecisao: (situacaoRelatorioItem, dtAprovacao, dtReprovacao) => {
    if (situacaoRelatorioItem === 3) {     // Relatório aprovado.
      return dtAprovacao
    } else if (situacaoRelatorioItem === 4) {     // Relatório reprovado.
      return dtReprovacao
    } else {
      return null
    }
  }
}

export default methods



// WEBPACK FOOTER //
// ./src/utils/relatorioTecnico.js